var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_1403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2.55 5 3 5.45 3 6V18C3 18.55 2.55 19 2 19C1.45 19 1 18.55 1 18V6C1 5.45 1.45 5 2 5ZM6 5C6.55 5 7 5.45 7 6V18C7 18.55 6.55 19 6 19C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5ZM22 5H10C9.45 5 9 5.45 9 6V18C9 18.55 9.45 19 10 19H22C22.55 19 23 18.55 23 18V6C23 5.45 22.55 5 22 5ZM11.64 16.19L13.11 14.33C13.31 14.08 13.68 14.08 13.89 14.32L15.29 16L17.39 13.29C17.59 13.03 17.98 13.03 18.18 13.29L20.39 16.19C20.64 16.52 20.41 16.99 19.99 16.99H12.03C11.62 17 11.38 16.52 11.64 16.19Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_1403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideShow);
export default __webpack_public_path__ + "static/media/slide_show.c4bff3c19d071d3f5222b59e8e4c1b27.svg";
export { ForwardRef as ReactComponent };